import { createSlice } from '@reduxjs/toolkit';

const loadingSlice = createSlice({
  name: 'loading',
  initialState: {
    isLoading: false,
    numLoading: 0
  },
  reducers: {
    startLoading(state, action) {
        state.numLoading++;
        state.isLoading = state.numLoading !== 0;
    },
    stopLoading(state, action) {
        state.numLoading--;
        if (state.numLoading < 0) state.numLoading = 0;//should not occur
        state.isLoading = state.numLoading !== 0;
    }
  },
});

export const loadingActions = loadingSlice.actions;

export default loadingSlice;